import { UAParser } from 'ua-parser-js';

window.autoGrowElement = function (element, maxLines) {
    element.style.height = 'auto'; // Reset height to auto to recalculate

    const additionalSpace = 2;
    if (maxLines) {
        const computedStyle = window.getComputedStyle(element);
        const lineHeight = parseFloat(computedStyle.lineHeight);
        const borderTop = parseFloat(computedStyle.borderTopWidth) || 0;
        const borderBottom = parseFloat(computedStyle.borderBottomWidth) || 0;
        const paddingTop = parseFloat(computedStyle.paddingTop) || 0;
        const paddingBottom = parseFloat(computedStyle.paddingBottom) || 0;
        const maxHeight = (lineHeight * maxLines) + borderTop + borderBottom + paddingTop + paddingBottom + additionalSpace;
        element.style.height = Math.min(element.scrollHeight + additionalSpace, maxHeight) + "px";
    } else {
        element.style.height = element.scrollHeight + additionalSpace + "px";
    }
};

window.clearAutoGrowElement = function (element) {
    element.style.height = null;
}

window.isDesktop = function() {
    return typeof(window.external?.sendMessage) !== 'undefined';
}

window.getPlatform = function() {
    return navigator.platform;
}

window.downloadGeneratedFile = function(filename, contentType, content) {
    // Create the URL
    const file = new File([content], filename, { type: contentType });
    const exportUrl = URL.createObjectURL(file);

    // Create the <a> element and click on it
    const a = document.createElement("a");
    document.body.appendChild(a);
    a.href = exportUrl;
    a.download = filename;
    a.target = "_self";
    a.click();

    // We don't need to keep the object URL, let's release the memory
    // On older versions of Safari, it seems you need to comment this line...
    URL.revokeObjectURL(exportUrl);
}

window.downloadFile = function (url, token) {
    let form = document.createElement('form')
    form.method = 'post'
    form.target = '_blank'
    form.action = url
    form.innerHTML = '<input type="hidden" name="access_token" value="' + token + '">'

    document.body.appendChild(form)
    form.submit()
    document.body.removeChild(form)
}

window.focusElement = function (element) {
    element.focus();
}

window.blurElement = function (element) {
    element.blur();
}

window.isInDialogLayer = function(element) {
    let modalContainers = document.getElementById("modal-containers");
    if (modalContainers == null) return false;
    return modalContainers.contains(element);
}

window.isFocusWithin = function (element) {
    return element.contains(document.activeElement) || document.activeElement === element;
};

window.requestFullscreen = async function(element) {
    try {
        // Headless chrome just stalls on requestFullScreen
        // We don't need to open in full screen if we are in headless.
        if (/HeadlessChrome/.test(window.navigator.userAgent)) return;
        if (element) {
            await element.requestFullscreen();
        } else {
            await document.body.requestFullscreen();
        }
    } catch (err) {
        console.warn("Full screen error:" + err);
    }
}



window.exitFullscreen = async function() {
    try {
        await document.exitFullscreen();
    } catch (err) {
        console.warn("Full screen error:" + err);
    }
}

window.isFullscreen = function() {
    return !(!document.isFullScreen &&
    !document.fullscreenElement &&
    !document.webkitFullscreenElement &&
    !document.mozFullScreenElement &&
    !document.msFullscreenElement);
}

window.cacheImages = function(imageList) {
    imageList.forEach(function(path) { new Image().src=path } );
}

window.setAudioOutputDevice = function(element, speakerDeviceId) {
    if (typeof speakerDeviceId !== 'undefined' && speakerDeviceId !== null && element != null && 'setSinkId' in HTMLAudioElement.prototype) {
        element.setSinkId(speakerDeviceId);
    }
}

document.addEventListener('fullscreenchange', function() {
    DotNet?.invokeMethodAsync('TeamReadyUI', 'FullScreenChanged', window.isFullscreen());
});


window.wakeLock = null;

if ('wakeLock' in navigator) {
    window.requestWakeLock = async function () {
        try {
            window.wakeLock = await navigator.wakeLock.request('screen');
        } catch (err) {
            console.warn("The Wake Lock request has failed - usually system related, such as battery.")
        }
    }
    window.releaseWakeLock = function () {
        if (window.wakeLock != null) {
            window.wakeLock.release().then(() => window.wakeLock = null)
        }
    }
} else {
    window.requestWakeLock = function() {
        console.warn("Wake log not supported by browser.")
    }
    window.releaseWakeLock = function() {}
}

let windows = {};
window.openWindow = function(url, name, features) {
    windows[name] = window.open(url, name, features);
}

window.closeWindow = function(name) {
    let window = windows[name];
    if (window) {
        window.close();
        delete windows[name];
    }
}

window.messageWindow = function(name, message) {
    if (name === 'parent') {
        window.opener.parent.postMessage({message:message});
    } else {
        windows[name].postMessage({message:message});
    }
}

window.subscribeToWindowMessage = (dotNetObjectReference) => {
    window.addEventListener("message", (event) => {
        const isObject = typeof event.data === 'object' && !Array.isArray(event.data) && event.data !== null;
        if (!isObject || !('message' in event.data)) return;
        dotNetObjectReference.invokeMethodAsync('OnMessage', event.data.message);
    });
}

window.getDetectedSystemInfo = () => {
    // UAParser should be available globally (window.UAParser)
    const parser = new UAParser();
    const result = parser.getResult();
    return {
        Browser: result.browser.name || "unknown",
        BrowserVersion: result.browser.version || "0.0",
        Engine: result.engine.name || "Unknown",
        OS: result.os.name || "Unknown",
        OSVersion: result.os.version || "Unknown",
        DeviceType: result.device.type || "Desktop",
        FormFactor: result.device.type === 'mobile' || result.device.type === 'tablet' ? 'Mobile' : 'Desktop',
        Width: window.innerWidth,
        Height: window.innerHeight
    };
};

// window.addEventListener('DOMContentLoaded', (event) => {
//     const UNKNOWN_VERSION="0.0"
//     function getBrowserInfo(){const e=[{name:"edge",engine:"Edge",key:"Edge",masks:[new RegExp("Edge/(\\d+.\\d+)")]},{name:"edgeanaheim",engine:"Chromium",key:"Edg",masks:[new RegExp("Edg/(\\d+.\\d+)")]},{name:"chromium",engine:"Chromium",key:"Chromium",masks:[new RegExp("Chromium/(\\d+.\\d+)")]},{name:"opera",engine:"Chromium",key:"OPR",masks:[new RegExp("OPR/(\\d+.\\d+)")]},{name:"yandexbrowser",engine:"Chromium",key:"YaBrowser",masks:[new RegExp("YaBrowser/(\\d+.\\d+)")]},{name:"chrome",engine:"Chromium",key:"Chrome",masks:[new RegExp("Chrome/(\\d+.\\d+)")]},{name:"firefox",engine:"Firefox",key:"Firefox",masks:[new RegExp("Firefox/(\\d+.\\d+)")]},{name:"safari",engine:"Safari",key:"Safari",masks:[new RegExp("Version/(\\d+.\\d+).*?Safari/")]},{name:"ie",engine:"MSIE",key:"Trident",masks:[new RegExp("MSIE (\\d+.\\d+)"),new RegExp("rv:(\\d+.\\d+)")]}],t=navigator.userAgent;let n={name:"unknown",engine:"Unknown",version:UNKNOWN_VERSION,formFactor:"Unknown"};return e.some((e=>-1!==t.indexOf(e.key)&&(n={name:e.name,engine:e.engine,version:getBrowserVersion(t,e.masks),formFactor:getFormFactor(t)},!0))),n}
//     function getBrowserVersion(e,t){let n=[];if(t.some((t=>(n=e.match(t),!!n))),!n||n.length<2)return UNKNOWN_VERSION;return n[1]||UNKNOWN_VERSION}function getFormFactor(e){return/iPhone|iPad|iPod|Android|Mobi/i.test(e)?"Mobile":"Desktop"}
//
//     let n = getBrowserInfo();
//     if(("chrome"!==n.name&&"chromium"!==n.name&&"edgeanaheim"!==n.name&&"safari"!==n.name&&"firefox"!==n.name) || n.formFactor!=='Desktop') {
//         window.location.href = "/notsupported.html";
//     }
//    
//     if (n.name === "safari" && n.version < 16.4) {
//         window.location.href = "/notsupported.html";
//     }
// });

/* observeElementSize: Listens to a html element for any changes in size. If the element is resized, the "OnSizeChanged"
* method is called.
* 
* arg: element (ElementReference): the element for whose resizes you'd like to listen to
* arg: dotNetHelper (DotNetObjectReference): reference for the component which contains the method you'd like to call as a callback
* if the element is resized.
* */
window.observeElementSize = (element, dotNetHelper) => {
    if(!element || !(element instanceof HTMLElement)) return null;

    let debounceTimer;
    // we create a resizeObserver function and then apply it to the requested element
    const resizeObserver = new ResizeObserver(entries => {
        // any time the element changes size, run the following code:
        clearTimeout(debounceTimer);
        // we add a debouncer function so that the resize callback isn't called in an endless loop
        debounceTimer = setTimeout(() => {
            // we only want to observe the resizing of a single element in this function
            if (entries.length === 0) return;
            if (entries > 1) console.warn("Observe element size only handles a single element");
            const entry = entries[0];
            // set width and height to the new values
            const { width, height } = entry.contentRect;
            // call OnElementSizeChanged JSInvokable method with the new width and height
            dotNetHelper.invokeMethodAsync('OnElementSizeChanged', width, height);
        }, 100);
    });

    resizeObserver.observe(element);
    return resizeObserver;
};


/* autoFitTextToCanvas:
* This function creates a canvas which takes up the full size of the parent element, and then renders text on 
* it. The text will be the largest possible font size (clamped between the maxFontSize and minFontSize) for which 
* it still fits on the canvas/parent element. If the text is still too large for the canvas at the minimum font size,
* the text will be truncated. If the minimum font size is reached, and there are any words that are longer than the 
* width of the canvas, they too will be truncated in line. 
* 
* Note that, by default, the text rendered will be white text with a 4px black shadow. If shadowSize is given, this 
* default will remain in tact, but the shadow blur will be adjusted as requested. If however, any of textShadow, 
* textGradientTop, textGradientBottom, or textFill are provided, all text styling defaults are overrided, and the dev
* becomes responsible for all styling. Note that this is so that the blazor component can be left in charge of default
* behaviours with fallback values for parameters.
* 
* arg: canvas (ElementReference): ElementReference to the canvas html element in blazor
* arg: text (string): the text you would like to render to the canvas
* arg: maxFontSize (int): the preferred size of font you would like to render. This is the maximum size that the font
* could be. The function will endeavour to choose a font size as close as possible to this value.
* arg: minFontSize (int): The minimum size the font size could be. If there is still too much text at this font size,
* the text will be truncated.
* arg: textFill (string): The css color key word of the color of the text rendered in the canvas. Note, if there are any
* gradient text colors given, the textFill argument will be ignored
* arg: textShadow (string): The css color key word of the text shadow. 
* arg: shadowSize (int):
* arg: fontWeight (int): The weight of the font. Note that canvas's limitations on textStyling mean that the text will
* simply be rendered as bold for values between 700-900, and as normal for values between 100-600.
* arg: textAlign (string): The horizontal alignment of the text block. Options are "left", "center", "right"
* arg: textBaseline (string): The vertical alignment of the text block. Options are "top", "middle", "bottom"
* */
window.autoFitTextToCanvas = function (canvas, text, maxFontSize, minFontSize, textFill=null, textShadow = null, textGradientTop = null, textGradientBottom=null, shadowSize=4, fontWeight = 400, textAlign = "left", textBaseline="top") {

    // to remove render blurriness of the text, we apply some styles to the canvas:
    if (canvas) {
        canvas.style.imageRendering = "optimizeSpeed";
        canvas.style.imageRendering = "crisp-edges";
        canvas.style.imageRendering = "-moz-crisp-edges";
        canvas.style.imageRendering = "-o-crisp-edges";
        canvas.style.imageRendering = "-webkit-optimize-contrast";
        canvas.style.msInterpolationMode = "nearest-neighbor";
    }
    // To remove blurriness and ensure that the canvas doesn't act as if it is a different size than its
    // html size, we set the canvas size to its bounding client size. We also adjust for the device pixel ratio to
    // further reduce blurriness
    const rect = canvas.getBoundingClientRect();
    canvas.width = Math.round(rect.width * window.devicePixelRatio);
    canvas.height = Math.round(rect.height * window.devicePixelRatio);
    if(canvas.width <= 0 || canvas.height <= 0){
        console.warn("Canvas dimensions not possible to render to. AutoFitText javascript function: width of canvas: " + canvas.width + "px. Height of canvas: " + canvas.height + "px");
        return null;
    }
    if(String.length <= 0){
        console.warn("No text given to the autoFitText javascript function to render.");
        return null;
    }
    const context = canvas.getContext("2d");
    context.clearRect(0, 0, canvas.width, canvas.height);
    function calculateTextHeight(fontSize, lineCount, lineSpacing = 1.2) {
        return fontSize * lineCount * lineSpacing;
    }

    function isRenderedTextTooLargeForLine(line, maxWidth) {
        return context.measureText(line).width > maxWidth;
    }

    function canDownsizeText(fontSize, minFontSize) {
        return fontSize > minFontSize;
    }

    function truncateWord(word, maxWidth) {
        let truncatedWord = word;
        if(truncatedWord){
            while (context.measureText(truncatedWord + '...').width > maxWidth && truncatedWord.length > 1) {
                truncatedWord = truncatedWord.slice(0, -1); // Remove the last character
            }
            return truncatedWord + '...';
        } else {
            return null
        }
    }

    function splitTextIntoLines(fontSize, text, maxWidth) {
        context.font = `${fontWeight} ${fontSize}px Arial`;
        const words = text.split(' ');
        const lines = [];
        let currentLine = '';

        for (let word of words) {
            let testLine = currentLine + (currentLine ? ' ' : '') + word;

            // Check if the word fits in the current line
            if (isRenderedTextTooLargeForLine(testLine, maxWidth)) {
                if (currentLine) {
                    lines.push(currentLine);
                    currentLine = '';
                }

                testLine = word;
            }

            currentLine = testLine;
        }

        if (currentLine) {
            lines.push(currentLine);
        }

        return lines;
    }

    let fontSize = maxFontSize;
    let lines = splitTextIntoLines(fontSize, text, canvas.width);
    let textHeight = calculateTextHeight(fontSize, lines.length);

    // Step 1: Gradually downsize the text until it fits within the canvas
    while ((textHeight > canvas.height || lines.some(line => isRenderedTextTooLargeForLine(line, canvas.width))) && canDownsizeText(fontSize, minFontSize)) {
        // we downsize by 15% of the font each loop, rather than size by size, to improve performance of the component
        fontSize = Math.max(Math.floor(fontSize * 0.85), minFontSize);
        lines = splitTextIntoLines(fontSize, text, canvas.width);
        textHeight = calculateTextHeight(fontSize, lines.length);
    }

    // Step 2: Handle truncation only if text doesn't fit even after downsizing to the minimum font size
    if (!canDownsizeText(fontSize, minFontSize) && (textHeight > canvas.height || lines.some(line => isRenderedTextTooLargeForLine(line, canvas.width)))) {
        lines = lines.slice(0, Math.floor(canvas.height / (fontSize * 1.2)));

        // If any lines are wider than the canvas (in the instance of very long words), truncate that individual line
        let i = 0
        lines.forEach(line => {
            if(isRenderedTextTooLargeForLine(line, canvas.width)){
                lines[i] = truncateWord(line, canvas.width);
            }
            i++;
        })

        // if there are still more lines than can fit in the canvas, truncate the last rendered line.
        // note that we simply select the last element in lines, as we previously sliced the lines array to ensure it
        // fits on the canvas.
        if(textHeight > canvas.height){
            lines[lines.length - 1] = truncateWord(lines[lines.length - 1], canvas.width);
        }
    }

    // note that fontWeight, despite being a number, will automatically convert to 'normal' (100-600) or 'bold' (700-900)
    context.font = `${fontWeight} ${fontSize}px Arial`;
    if(textAlign !== "center" && textAlign !== "right" && textAlign !== "left"){
        textAlign = "center"
    }
    if(textBaseline !== "bottom" && textBaseline !== "top" && textBaseline !== "middle"){
        textBaseline = "top"
    }

    context.textAlign = textAlign;
    context.textBaseline = textBaseline;

    const lineHeight = fontSize * 1.2;
    const totalTextHeight = lines.length * lineHeight;
    let startY
    let topOfText
    if(textBaseline === "top"){
        startY = 0
        topOfText = 0
    } else if(textBaseline === "bottom"){
        startY = (canvas.height - totalTextHeight) + lineHeight
        topOfText = (canvas.height - totalTextHeight) + (lineHeight - fontSize)
    } else {
        startY = (canvas.height - totalTextHeight) / 2 + lineHeight / 2;
        topOfText = (canvas.height - totalTextHeight) /2 + (lineHeight - fontSize)/ 2;
    }



    // Step 3: Rendering and styling of text
    if(!textFill && !textShadow && !textGradientTop && !textGradientBottom){
        // No styling has been provided, render defaults.
        // Only shadowSize parameter can be changed for the default styled text.
        context.shadowColor = "black";
        context.shadowBlur = shadowSize === 0 ? 4 : shadowSize; // if shadowSize was null, make it 4px, for default styling
        context.fillStyle = "white"; // White text
    } else {
        if(textShadow){
            context.shadowColor = textShadow;
            context.shadowBlur = shadowSize === 0 ? 4 : shadowSize;
        }
        if (textGradientTop || textGradientBottom){
            // we have to add a new gradient stop for each line of text, so that each letter has its own gradient.
            // note that if either top or bottom gradient are not given, the gradient will simply go from given value
            // to transparent
            const gradient = context.createLinearGradient(0, 0, 0, canvas.height);
            let i = 0 // line counter
            lines.forEach(line => {
                // calculate the proportion of the vertical space above the letters. Note 1.2 is the vertical letter spacing
                gradient.addColorStop((topOfText +  i * lineHeight)/canvas.height, textGradientTop ?? "transparent"); // Top color. We add a small amount so that the top and bottom gradients aren't on top of one another
                /*        context.beginPath();
                        context.moveTo(0, (topOfText +  i * lineHeight + 1)); // Start at the left edge of the canvas
                        context.lineTo(canvas.width, (topOfText +  i * lineHeight)); // Draw to the right edge
                        context.stroke();*/
                // calculate the proportion of the vertical space above the letters plus this new letter. Note 1.2 is the vertical letter spacing
                gradient.addColorStop((topOfText +  i * lineHeight + fontSize)/canvas.height, textGradientBottom ?? "transparent"); // Bottom color. We subtract a small amount so that the top and bottom gradients aren't on top of one another
                /* context.beginPath();
                 context.moveTo(0, (topOfText +  i * lineHeight + fontSize)); // Start at the left edge of the canvas
                 context.lineTo(canvas.width, (topOfText +  i * lineHeight + fontSize)); // Draw to the right edge
                 context.stroke();*/
                i++
            })
            context.fillStyle = gradient;
        } else if (textFill){
            context.fillStyle = textFill;
        }
    }
    // render all lines
    lines.forEach((line, index) => {
        let x;
        if (textAlign === "left") {
            x = 0;
        } else if (textAlign === "right") {
            x = canvas.width;
        } else {
            x = canvas.width / 2; // "center"
        }

        let y = startY + index * lineHeight

        context.fillText(line, x, y);
    });
}

window.getElementWidth = (element) => {
    if (!element) return 0;
    return parseInt(window.getComputedStyle(element).width)
};

window.getElementHeight = (element) => {
    if (!element) return 0;
    return parseInt(window.getComputedStyle(element).height)
};

window.getParentBoundingClientRect = (element) => {
    return getBoundingClientRect(element?.parentElement)
};

window.getBoundingClientRect = (element) => {
    if (element == null) return null;
    const rect = element.getBoundingClientRect();
    return {
        left: rect.left,
        top: rect.top,
        right: rect.right,
        bottom: rect.bottom,
        width: rect.width,
        height: rect.height,
        scrollWidth: element.scrollWidth,
        scrollHeight: element.scrollHeight
    }
};

window.trackElementDrag = (dotNetHelper) => {
    function onMouseMove(e) {
        dotNetHelper.invokeMethodAsync('UpdatePosition', e.clientX);
    }
    function onMouseUp(e) {
        window.removeEventListener('mousemove', onMouseMove);
        window.removeEventListener('mouseup', onMouseUp);
        dotNetHelper.invokeMethodAsync('EndDrag');
    }
    window.addEventListener('mousemove', onMouseMove);
    window.addEventListener('mouseup', onMouseUp);
};

window.getImageDimensions = (imageUrl) => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
            resolve({ width: img.width, height: img.height });
        };
        img.onerror = reject;
        img.src = imageUrl;
    });
};

window.createCanvasWithScaledImage = async function (canvas, imageUrl, scaleFactor, isBackgroundBlurred = false, bgColorFill="") {
    const ctx = canvas.getContext("2d");
    const img = new Image();
    img.setAttribute('crossorigin', 'anonymous');
    img.src = imageUrl;
    img.onload = function () {
        const scaledWidth = img.width * scaleFactor;
        const scaledHeight = img.height * scaleFactor;

        const x = (canvas.width - scaledWidth) / 2;
        const y = (canvas.height - scaledHeight) / 2;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        if (bgColorFill !== "" && bgColorFill !== null) {
            ctx.fillStyle = bgColorFill;
            ctx.fillRect(0, 0, canvas.width, canvas.height);
        }
        if(isBackgroundBlurred){
            ctx.filter = 'blur(20px)';
            ctx.globalAlpha = 0.3; // 30% opacity
            ctx.drawImage(img, -20, -20, canvas.width+20, canvas.height+20); // 20px blur
        }
        ctx.filter = 'none';
        ctx.globalAlpha = 1;
        ctx.drawImage(img, x, y, scaledWidth, scaledHeight);
    };    
};


window.convertCanvasToPng = async (canvas) => {
    if (!canvas) return null;
    return URL.createObjectURL(await new Promise(resolve => canvas.toBlob(resolve, "image/png")));
};

window.hotkeyInterop = (function () {
    let dotNetRef = null;
    let registered = false;
    let pressedKeys = new Set();

    // Normalize hotkey string: e.g. "ctrl+shift+space"
    function normalizeHotkey(e) {
        let keys = [];
        if (e.ctrlKey) keys.push('ctrl');
        if (e.altKey) keys.push('alt');
        if (e.shiftKey) keys.push('shift');
        if (e.metaKey) keys.push('meta');
        // Use event.code for non-modifier key
        let key = e.code || e.key;
        // For space, use 'space'
        if (key === 'Space' || key === ' ') key = 'space';
        else key = key.toLowerCase();
        // Only add non-modifier key if not a pure modifier
        if (!['controlleft', 'controlright', 'shiftleft', 'shiftright', 'altleft', 'altright', 'metaleft', 'metaright'].includes(key))
            keys.push(key);
        return keys.join('+');
    }

    function onKeyDown(e) {
        // Prevent repeated firing for held keys
        if (e.repeat) return;
        const hotkey = normalizeHotkey(e);
        if (dotNetRef) {
            dotNetRef.invokeMethodAsync('OnHotkeyPressed', hotkey);
        }
    }

    return {
        registerListener: function (dotNetObjectRef) {
            if (registered) return;
            dotNetRef = dotNetObjectRef;
            window.addEventListener('keydown', onKeyDown, true);
            registered = true;
        },
        unregisterListener: function () {
            if (!registered) return;
            window.removeEventListener('keydown', onKeyDown, true);
            dotNetRef = null;
            registered = false;
        }
    };
})();
